<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header text-center d-block">
      <h4 class="text-primary">Please select a relevant option to begin</h4>
      <!-- <button type="button" (click)="close()"  class="close-modal">
          <i class="icon-cross-small"></i>
        </button> -->
    </div>
    <div class="modal-body">
      <form class=" form-row" [formGroup]="form">
        <div class="form-group col-12">
          <div class="radio-wrap " *ngFor="let type of supportType;let i = index">
            <input type="radio" [id]="i" formControlName="supportType" (change)="supportTypeVaue(type)"
              [value]="type.support" [checked]="i" />
            <label class="radio-label m-0 py-3 align-items-center px-2" [for]="i">
              <div class="request-type">
                <span class="support-title text-primary">{{type.support}}</span>
                <span class="mb-0 d-block description text-gray" >{{type.description}}</span></div>
            </label>
           
           
          </div>
          <!-- <div class="radio-wrap">
                      <input type="radio" name="decision" id="transaction" ><label class="radio-label" for="transaction">Transaction Issue</label>
                     </div> -->
  
        </div>
      </form>
      <div class="_footer mt-auto justify-content-center text-center">
  
        <button type="button" class="btn btn-outline-primary m-2" autofocus (click)="close()">
          Cancel
        </button>
        <button type="button" [disabled]="!form.valid" class="btn btn-primary m-2" (click)="category()">
          Next
        </button>
      </div>
    </div>
  
  </div>
</div>
